// src/services/api/businessCourier.js
import { apiClient } from './base';

export const getBusinessCouriers = async (params = {}) => {
  try {
    const response = await apiClient.get('/business-couriers', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const assignCouriersToBusiness = async (courierAccounts) => {
  try {
    const response = await apiClient.post('/business-couriers', {
      courierAccounts
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateBusinessCourier = async (businessCourierId, updateData) => {
  try {
    const response = await apiClient.put(`/business-couriers/${businessCourierId}`, updateData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const removeBusinessCourier = async (businessCourierId) => {
  try {
    const response = await apiClient.delete(`/business-couriers/${businessCourierId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const enableWebhook = async (businessCourierId) => {
  try {
    const response = await apiClient.post(`/business-couriers/${businessCourierId}/webhook/enable`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const disableWebhook = async (businessCourierId) => {
  try {
    const response = await apiClient.post(`/business-couriers/${businessCourierId}/webhook/disable`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const regenerateWebhookSecret = async (businessCourierId) => {
  try {
    const response = await apiClient.post(`/business-couriers/${businessCourierId}/webhook/regenerate`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCourierStatuses = async () => {
  try {
    const response = await apiClient.get('/business-couriers/courier-statuses');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getColumnMappingOverrides = async (businessCourierId) => {
  try {
    const response = await apiClient.get(`/business-couriers/${businessCourierId}/column-mappings`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createColumnMappingOverride = async (businessCourierId, data) => {
  try {
    const response = await apiClient.post(`/business-couriers/${businessCourierId}/column-mappings`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateColumnMappingOverride = async (businessCourierId, mappingId, data) => {
  try {
    const response = await apiClient.put(`/business-couriers/${businessCourierId}/column-mappings/${mappingId}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteColumnMappingOverride = async (businessCourierId, mappingId) => {
  try {
    const response = await apiClient.delete(`/business-couriers/${businessCourierId}/column-mappings/${mappingId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getCourierDeliveryCharges = async (businessCourierId) => {
  try {
    const response = await apiClient.get(`/business-couriers/${businessCourierId}/delivery-charges`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCourierDeliveryCharges = async (businessCourierId, deliveryCharges) => {
  try {
    const response = await apiClient.put(`/business-couriers/${businessCourierId}/delivery-charges`, {
      deliveryCharges
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
